const OCR_PLAN_SERVICES = [
  "yandex_cloud_recognize_document",
  "opper_recognize_document",
];

export function hasOcrPlanService(plan, now = new Date()) {
  if (!plan || !Array.isArray(plan.included_services)) return false;
  if (plan.trial_end && new Date(plan.trial_end) > now) return false;

  return OCR_PLAN_SERVICES.some((service) => plan.included_services.includes(service));
}
